export enum PatientState {
  New = 'new',
}
